export default __webpack_public_path__ + "static/media/photo--lg--misc-15.cf28d054.jpg";